import React from 'react';
import { CheckCircle, Trash2, X, Users } from 'lucide-react';
import Button from '../../../components/ui/Button';

const BulkActionsPanel = ({
  selectedCount,
  onClearSelection,
  onBulkVerify,
  onBulkDelete
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="h-8 w-8 rounded-md bg-muted/40 border border-border flex items-center justify-center mr-3">
            <Users className="w-4 h-4 text-muted-foreground" />
          </div>
          <span className="text-sm font-medium text-foreground">
            {selectedCount} notaire{selectedCount > 1 ? 's' : ''} sélectionné{selectedCount > 1 ? 's' : ''}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onBulkVerify}
            className="text-green-700 border-green-200 hover:bg-green-50"
          >
            <CheckCircle className="w-4 h-4 mr-1.5" />
            Vérifier
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onBulkDelete}
            className="text-destructive border-destructive/30 hover:bg-destructive/10"
          >
            <Trash2 className="w-4 h-4 mr-1.5" />
            Supprimer
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
          >
            <X className="w-4 h-4 mr-1.5" />
            Annuler
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsPanel;